const state = {
	device: 'desktop',
	config: {},
	provinceList: [],
	navigation: [],
	footer_navigation: [],
	help_center: [],
	categoryList: [
		"招标公告",
		"中标公告",
		"拟在建项目",
		"VIP项目",
		"独家项目",
	],
	seo_list: []
}

const mutations = {
	TOGGLE_DEVICE: (state, device) => {
		state.device = device
	},
	SET_CONFIG: (state, payload) => {
		state.config = payload;
	},
	SET_PROVINCE_LIST: (state, payload) => {
		state.provinceList = payload;
	},
	SET_NAVIGATION: (state, payload) => {
		state.navigation = payload;
	},
	SET_FOOTER_NAVIGATION: (state, payload) => {
		state.footer_navigation = payload;
	},
	SET_HELP_CENTER: (state, payload) => {
		state.help_center = payload;
	},
	SET_SEO_LIST: (state, payload) => {
		state.seo_list = payload;
	}
}

const actions = {
	toggleDevice({ commit }, device) {
		commit('TOGGLE_DEVICE', device)
	},
	toggleConfig({ commit }, config) {
		commit("SET_CONFIG", config);
	},
	toggleProvinceList({ commit }, provinceList) {
		commit("SET_PROVINCE_LIST", provinceList);
	},
	toggleNavigation({ commit }, navigation) {
		commit("SET_NAVIGATION", navigation);
	},
	toggleFooterNavigation({ commit }, footer_navigation) {
		commit("SET_FOOTER_NAVIGATION", footer_navigation);
	},
	toggleHelpCenter({ commit }, help_center) {
		commit("SET_HELP_CENTER", help_center);
	},
	toggleSeoList({ commit }, seo_list) {
		commit("SET_SEO_LIST", seo_list);
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js